import { jsx as _jsx } from "react/jsx-runtime";
import { OGPortConfiguredIcon } from '@opengear/icons/ports/port-configured';
import { OGPortUnconfiguredIcon } from '@opengear/icons/ports/port-unconfigured';
export function PortStateCell(_a) {
    var port = _a.port;
    return port.mode === 'consoleServer' ? (_jsx(OGPortConfiguredIcon, { fontSize: "medium", sx: { height: 21, marginLeft: 1 } })) : (_jsx(OGPortUnconfiguredIcon, { fontSize: "medium", sx: { height: 21, marginLeft: 1 } }));
}
